const CREDIT = 'credit';
const OPEN_YOUNG = 'open-young';
const PAYROLL_ACCOUNT = 'payroll-account';

module.exports = {
    ASNEF: 'asnef',
    ACCIDENTS_INSURANCE: 'accidents_insurance',
    ACCOUNT_DEBITS: 'account_debits',
    ADVANCED_ORDER_SPANISH_STOCKS: 'advanced_order_spanish_stocks',
    AGGREGATOR: 'aggregator',
    BASIC_ACCOUNT: 'web-basic-account-consents-off-enabled',
    AMAZON_GIFT_CARD: 'amazon_gift_card',
    BRING_MY_FUNDS: 'bring_my_funds',
    BIZUM: 'bizum',
    CHAT: 'chat',
    CHEQUES: 'cheques',
    CREDIT,
    DIVERSIFIED_INVESTMENT_FUNDTRANSFER: 'diversified_investment_fundtransfer',
    ES_COUNTRY: 'es_country',
    ETFS_DETAILS: 'etfs_details',
    FUND_GLOSSARY: 'fund_glossary',
    FUNDS_TRANSFER: 'funds_transfer',
    GC: 'gc',
    INSURANCES: 'home-insurance-enabled',
    INVESTMENTS: 'investments',
    INVESTMENT_PRODUCTS_LIST: 'investment_products_list',
    JOIN_HOLDERS: 'join_holders',
    LOANS_MORTGAGES: 'loans_mortgages',
    MIFID: 'mifid',
    MORTGAGE_INSURANCES: 'mortgage-home-insurance-enabled',
    NOTIFICATIONS_MANAGEMENT: 'notifications_management',
    OPENTRADER: 'opentrader',
    OPEN_YOUNG,
    PAYROLL_ACCOUNT,
    PFM: 'pfm_countries',
    PROVINCE: 'province',
    REFERRALS: 'referrals',
    ROBO: 'robo',
    SAVINGS: 'savings',
    SOLIDARITY: 'solidarity',
    STOCK_DETAILS: 'stock_details',
    TAXATION: 'taxation',
    TOPUP_MOBILE: 'topup_mobile',
    TRANSFER_EXTERNAL_SECURITIES: 'transfer-external-securities',
    TUTORIAL: 'tutorial',
    TYPE_ETFS: 'type_etfs',
    TYPE_FUNDS: 'type_funds',
    TYPE_OF_ROAD: 'type_of_road',
    TYPE_PLANS: 'type_plans',
    TYPE_STOCKS: 'type_stocks',
    TYPE_WARRANTS: 'type_warrants',
    WARRANTS_DETAILS: 'warrants_details',
    WB_CRF: 'wb_crf',
    NOT_ALLOWED_CONTRACT_URLS_COUNTRIES: {
        'duo-combined-deposit': CREDIT,
        'junior-account': OPEN_YOUNG,
        'open-young': OPEN_YOUNG,
        'personal-loan': CREDIT,
        'pre-approved-loan': CREDIT,
        'pre-granted-credit': CREDIT,
        'upgrade-to-payroll-account': PAYROLL_ACCOUNT,
    },
    VIRTUAL_CREDIT_CARD: 'hire-card-virtual-credit-enabled',
    VIRTUAL_DEBIT_CARD: 'virtual-debit-card-hiring-enabled',
    OPEN_YOUNG_CARD: 'hire-card-openyoung-enabled',
    PACK_OPEN_YOUNG_ACCOUNT: 'hire-pack-openyoung-enabled',
    TREND: 'trend',
    NOT_ALLOWED_WEALTH_PRODUCT_NAME_FROM_CATALOGUE_COUNTRIES:
        'wealth_product_name_from_catalogue',
};
